(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-category-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function scrollStep(track) {
      return Math.min(Math.round(track.clientWidth * 0.75), 420);
    }

    function updateDisabled(track, prev, next) {
      if (!track || !prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 2) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function init(root) {
      if (!root || root.getAttribute('data-cc-ccn-ready')) return;
      var useSlider = root.getAttribute('data-cc-ccn-slider') === 'true';
      if (!useSlider) return;

      var track = root.querySelector('[data-cc-ccn-track]');
      var prev = root.querySelector('[data-cc-ccn-prev]');
      var next = root.querySelector('[data-cc-ccn-next]');
      if (!track || !prev || !next) return;

      root.setAttribute('data-cc-ccn-ready', 'true');

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollStep(track), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollStep(track), behavior: 'smooth' });
      });
      var onScrollOrResize = function () {
        updateDisabled(track, prev, next);
      };
      track.addEventListener('scroll', onScrollOrResize);
      window.addEventListener('resize', onScrollOrResize);
      onScrollOrResize();
    }

    document.querySelectorAll('[data-cc-ccn-root]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      event.target.querySelectorAll('[data-cc-ccn-root]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeless-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FADE_MS = 320;

    function getSectionEl(sectionId) {
      return document.getElementById('shopify-section-' + sectionId);
    }

    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-cc-timeless-select]');
      if (!sel) return;

      var root = sel.closest('[data-cc-timeless-root]');
      if (!root) return;

      var sectionId = root.getAttribute('data-section-id');
      var base = root.getAttribute('data-collections-base') || '/collections';
      var handle = sel.value;
      var wrap = root.querySelector('[data-cc-timeless-grid-wrap]');
      if (!sectionId || !wrap) return;

      wrap.classList.add('cc-timeless--fading');
      wrap.setAttribute('aria-busy', 'true');

      var url =
        base.replace(/\/$/, '') +
        '/' +
        encodeURIComponent(handle) +
        '?sections=' +
        encodeURIComponent(sectionId);

      fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          var html = json[sectionId];
          if (!html || typeof html !== 'string') {
            throw new Error('Timeless collections: missing section in response');
          }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.getElementById('shopify-section-' + sectionId);
          var current = getSectionEl(sectionId);
          if (incoming && current) {
            current.replaceWith(incoming);
          }
        })
        .catch(function (err) {
          console.error(err);
          var w = root.querySelector('[data-cc-timeless-grid-wrap]');
          if (w) {
            w.classList.remove('cc-timeless--fading');
            w.setAttribute('aria-busy', 'false');
          }
        })
        .finally(function () {
          setTimeout(function () {
            var el = getSectionEl(sectionId);
            if (!el) return;
            var newWrap = el.querySelector('[data-cc-timeless-grid-wrap]');
            if (newWrap) {
              newWrap.classList.remove('cc-timeless--fading');
              newWrap.setAttribute('aria-busy', 'false');
            }
          }, FADE_MS);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
